// ドロワーメニュー // Drawer menu
jQuery(function ($) {
	if ($('.l-hamburger').length > 0) {
		$('.l-hamburger').click(function () {
			var nav = $('.l-header .l-nav');
			var bg = $('.l-header .drawer_bg');
			var toggle = $(this);

			toggle.toggleClass('toggle_active');
			bg.fadeToggle();
			$('body').toggleClass('drawer_open');

			console.log(nav);
			if (toggle.hasClass('toggle_active')) {
				nav.removeClass('is_close');
				nav.addClass('is_open');
			} else {
				nav.removeClass('is_open');
				nav.addClass('is_close');
			}
		});

		$('.drawer_bg').click(function () {
			var bg = $(this);
			var nav = $('.l-header .l-nav');

			bg.fadeOut();
			$('.l-hamburger').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			nav.removeClass('is_open');
			nav.addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function () {
			// if (window.innerWidth <= 768) {
			if ($('.l-hamburger:visible').length > 0) {
				$('.l-hamburger').click();
			}
		});
	}
});